// Helper function για την ημερομηνία (π.χ. "2026-08-11T00:00:00Z" -> "11/08/26")
export function formatDate(dateString: string | null | undefined): string {
    if (!dateString) return '';
    
    const dateObj = new Date(dateString);
    if (isNaN(dateObj.getTime())) return ''; // Έλεγχος αν είναι έγκυρη ημερομηνία

    return dateObj.toLocaleDateString("el-GR", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit"
    });
}

// Helper function για την ώρα (π.χ. "21:45:55.9605400" -> "21:45:55")
export function formatTime(timeString: string | null | undefined): string {
    if (!timeString) return '';

    // Κόβει τα millisecond/ticks μετά την τελεία
    return timeString.split('.')[0];
}